import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const LoginAttemptWarningModal = ({ isOpen, onTryAgain, email }) => {
  const resetPasswordUrl = `/forgot?email=${encodeURIComponent(email || "")}`;

  return (
    <Modal isOpen={isOpen} toggle={onTryAgain} style={{ zIndex: 1000 }}>
      <ModalHeader toggle={onTryAgain} className="text-danger">
        One attempt remaining
      </ModalHeader>

      <ModalBody>
        <p>
          The password you entered is incorrect. You have one login attempt
          remaining before your account is temporarily locked for security.
        </p>
        <p>
          Forgot your password? You can reset it now and avoid a lockout.
        </p>
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" type="button" onClick={onTryAgain}>
          Try again
        </Button>
        <Button
          color="primary"
          type="button"
          onClick={() => {
            window.location.href = resetPasswordUrl;
          }}
        >
          Reset my password
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default LoginAttemptWarningModal;
